<p>colmec-init-working-order-object-step works!</p>
